import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { RequireAuth } from './components/RequireAuth';
import { AppLayout } from './components/AppLayout';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { RegisterAgency } from './pages/RegisterAgency';
import { Dashboard } from './pages/Dashboard';
import { AdminTenants } from './pages/AdminTenants';
import { Clients } from './pages/Clients';
import { ClientIntake } from './pages/ClientIntake';
import { ClientDetail } from './pages/ClientDetail';
import { Billing } from './pages/Billing';
import { ClientDashboard } from './pages/ClientDashboard';
import { Settings as SettingsPage } from './pages/Settings';
import { NotFound } from './pages/NotFound';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* ── Public routes ────────────────────────────────── */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register-agency" element={<RegisterAgency />} />

        {/* ── Agency dashboard routes (with sidebar) ──────── */}
        <Route
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/admin/tenants" element={<AdminTenants />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/clients/new" element={<ClientIntake />} />
          <Route path="/clients/:id" element={<ClientDetail />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>

        {/* ── Client Portal (separate, no sidebar) ────────── */}
        <Route
          path="/me"
          element={
            <RequireAuth>
              <ClientDashboard />
            </RequireAuth>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}